export default "__VITE_ASSET__DF_VDn23__"